import {Component, OnInit} from '@angular/core';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {UserService} from '~/app/core/services/user.service';
import {Router} from '@angular/router';
import {AuthServicesService} from 'mclane-webauth-lib';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {PreviewTemplateCopyComponent} from '~/app/web/setup/gl-codes-setup-template/preview-template-copy/preview-template-copy.component';
import {Store} from '@model/Store';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {HomeOffice} from '@model/HomeOffice';
import {StoreApGlXrefService} from '~/app/core/services/store-ap-gl-xref.service';
import {StoreConfig} from '@model/StoreConfig';
import {StoreConfigService} from '~/app/core/services/store-config.service';
import {Segments} from '@model/Segments';
import {StoreApGLXref} from '@model/StoreApGLXref';
import {TemplateCopyService} from '~/app/core/services/template-copy.service';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-gl-codes-setup-template',
  templateUrl: './gl-codes-setup-template.component.html',
  styleUrls: ['./gl-codes-setup-template.component.scss']
})
export class GlCodesSetupTemplateComponent implements OnInit {

  templateStoreList: any;
  targetStoreList: any;

  public selectedTemplateStore: Store;
  public selectedTargetStore: Store = new Store();
  public selectedHomeOffice: HomeOffice;

  segment: any;

  public storeConfigs: StoreConfig[] = [];
  public selectedTemplateStoreConfig: StoreConfig[] = [];
  public selectedTargetStoreConfig: StoreConfig[] = [];

  templateSegments: Segments[] = [];
  targetSegments: Segments[] = [];
  previewDisabled: boolean = true;

  templateExportedGLCode: string = '';
  targetExportedGLCode: string = '';

  templateGlCodes: string[] = [];
  targetGlCodes: string[] = [];

  public storeApGLXrefList: StoreApGLXref[] = [];

  targetSegmentMap = new Map();
  templateSegmentMap = new Map();

  formGroup: FormGroup;


  constructor(
              public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public userService: UserService,
              public router: Router,
              public authService: AuthServicesService,
              public templateCopyService: TemplateCopyService,
              public storeConfigService: StoreConfigService,
              public storeApGlXrefService: StoreApGlXrefService,
              public localStorage: LocalStorageIndexedService,
              public formBuilder: FormBuilder
              ) {
  }

  async ngOnInit() {
    // return;
    this.loadingIndicator.show();
    this.templateCopyService.changeSelectedTargetStore(new Store());
    this.templateCopyService.selectedTemplateStore.subscribe(store => this.selectedTemplateStore = store);
    this.templateCopyService.selectedTargetStore.subscribe(store => this.selectedTargetStore = store);

    if (this.userService.selectedHomeOffice === undefined) {
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.templateStoreList = await this.storeApGlXrefService.getStoreList(this.selectedHomeOffice.hoId, this.authService.getUsername().toUpperCase());
        this.templateStoreList.forEach(store => {
          store.display = store.chainID + ' - ' + store.storeID;
        });
        this.targetStoreList = this.templateStoreList;
        this.loadingIndicator.hide();
      } else {
        this.loadingIndicator.hide();
        this.dialogService.showErrorNotificationForDuration("No home office is selected.", 2000);
        await this.router.navigate([paths.home]);
      }
    } else {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
      this.templateStoreList = await this.storeApGlXrefService.getStoreList(this.selectedHomeOffice.hoId, this.authService.getUsername().toUpperCase());
      this.templateStoreList.forEach(store => {
        store.display = store.chainID + ' - ' + store.storeID;
      });
      this.targetStoreList = this.templateStoreList;
      this.loadingIndicator.hide();
    }
    if (this.templateStoreList && this.templateStoreList.length > 0) {
      this.selectedTemplateStore = this.templateStoreList[0];
      await this.templateStoreValueChange(this.selectedTemplateStore);

    }
    this.buildForm();

    this.loadingIndicator.hide();
  }

  get formSegments(): FormArray {
    return <FormArray>this.formGroup.get('segments');
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      segments: this.formBuilder.array([])
    });
  }

  segmentGroups() {
    return this.formBuilder.group({
      checkBox: new FormControl(),
      textBox: new FormControl(),
      previewButton: new FormControl()
    });
  }

  buildSegmentGroups() {
    console.log('templateGlCodes for formSegment Builder: ', this.templateGlCodes);
    let ind = 0;
    this.templateGlCodes.forEach(segment => {
      this.templateSegmentMap.set(ind, segment);
      ind++;
      this.formSegments.push(this.segmentGroups());
    });
    this.templateCopyService.changeTemplateSegmentMap(this.templateSegmentMap);
  }


  async populateTemplateStore(store: Store) {

    this.loadingIndicator.show();
    this.templateGlCodes = [];

    this.storeConfigs = await this.storeConfigService.getStoreConfig(store.hoID, this.authService.getUsername());
    this.selectedTemplateStoreConfig = this.storeConfigs.filter(store => {
      return store.store === this.selectedTemplateStore.storeID;
    });


    this.templateSegments = this.selectedTemplateStoreConfig[0] != null ? this.selectedTemplateStoreConfig[0].segments : [];
    if (this.selectedTemplateStore === this.selectedTargetStore) {
      this.dialogService.showErrorNotificationForDuration('Source and destination are the same. Copy not possible', 5000);
      this.previewDisabled = true;
    } else {
      if (this.templateSegments.length !== this.targetSegments.length) {
        // this.dialogService.showErrorNotificationForDuration('Segments do not match. This copy is not possible', 5000);
        this.previewDisabled = true;
      } else {
        this.previewDisabled = false;
      }
    }
    this.storeApGLXrefList = await this.storeApGlXrefService.getStoreApGlXrefList(store.hoID, store.chainID, store.storeID, this.authService.getUsername().toUpperCase());
    this.templateExportedGLCode = this.storeApGLXrefList.find(xref => xref.exportedGLCode !== null && xref.exportedGLCode !== '').exportedGLCode;
    let start = 0;
    this.templateSegments.forEach(template => {
      this.templateGlCodes.push(this.templateExportedGLCode.slice(start, start + template.length));
      start = start + template.length;
    });
    this.buildForm();
    this.buildSegmentGroups();

    this.loadingIndicator.hide();
  }

  async populateTargetStore(store: Store) {
    this.loadingIndicator.show();
    this.targetGlCodes = [];

    this.storeConfigs = await this.storeConfigService.getStoreConfig(store.hoID, this.authService.getUsername());
    this.selectedTargetStoreConfig = this.storeConfigs.filter(store => store.store === this.selectedTargetStore.storeID);

    this.targetSegments = this.selectedTargetStoreConfig[0].segments;
    if (this.selectedTemplateStore === this.selectedTargetStore) {
      this.dialogService.showErrorNotificationForDuration('Source and destination are the same. Copy not possible', 5000);
      this.previewDisabled = true;
    } else {
      if (this.templateSegments.length !== this.targetSegments.length) {
        this.dialogService.showErrorNotificationForDuration('Segments do not match. This copy is not possible', 5000);
        this.previewDisabled = true;
      } else {
        this.previewDisabled = false;
      }
    }

    this.storeApGLXrefList = await this.storeApGlXrefService.getStoreApGlXrefList(store.hoID, store.chainID, store.storeID, this.authService.getUsername().toUpperCase());
    // this.targetExportedGLCode = this.storeApGLXrefList.find(xref => xref.exportedGLCode != '').exportedGLCode;
    this.targetExportedGLCode = this.storeApGLXrefList.find(xref => xref.exportedGLCode !== null && xref.exportedGLCode !== '') ? this.storeApGLXrefList.find(xref => xref.exportedGLCode !== null && xref.exportedGLCode !== '').exportedGLCode : '';
    let start = 0;
    this.targetSegments.forEach(target => {
      this.targetGlCodes.push(this.targetExportedGLCode.slice(start, start + target.length));
      start = start + target.length;
    });
    this.loadingIndicator.hide();
  }


  preview() {

    const dialogRef = this.dialogService.open({
      type: DialogType.INFO,
      title: 'Preview',
      content: PreviewTemplateCopyComponent,
      actions: [
        {text: 'Apply', primary: true},
        {text: 'Cancel', primary: false},
      ],
      width: 600
    });

    const dialogContent = dialogRef.content.instance;
    dialogRef.result.subscribe((answer: any) => {
      if (answer.text === 'Apply') {
        this.templateCopyService.apply(this.selectedTargetStore.chainID, this.selectedTargetStore.storeID, dialogContent.gridData)
          .subscribe(() => {
            this.loadingIndicator.hide();
          });
        this.dialogService.showSuccessNotification('Update Successful');
      } else {
        this.loadingIndicator.hide();
      }
    });
  }

  templateStoreValueChange(store: Store) {
    this.templateCopyService.changeSelectedTemplateStore(store);
    this.selectedTemplateStore = store;
    this.populateTemplateStore(store).then(r => r);
  }

  targetStoreValueChange(store: Store) {
    this.templateCopyService.changeSelectedTargetStore(store);
    this.selectedTargetStore = store;
    this.populateTargetStore(store).then(r => r);
  }


  segmentCheckboxClicked(index: number, segment: AbstractControl) {

    let tbValue = this.templateGlCodes[index];
    this.formSegments.controls.forEach(segment => {
      if (!this.formSegments.controls[index].get('checkBox').value) {
        this.formSegments.controls[index].get('textBox').setValue(tbValue);
      } else {
        this.formSegments.controls[index].get('textBox').setValue('');
      }

      if (this.formSegments.controls[index].get('checkBox').value !== null && this.formSegments.controls[index].get('checkBox').value !== '') {
        // this.previewDisabled = false;
      } else {
        // this.previewDisabled = true;
      }
    });



    this.targetSegmentMap.set(index, this.formSegments.controls[index].get('textBox').value);
    this.templateCopyService.changeTargetSegmentMap(this.targetSegmentMap);
  }

  onChangeTemplateSegment($event: any, code: string, index: number) {
    this.templateSegmentMap.set(index, code);
    this.templateCopyService.changeTemplateSegmentMap(this.templateSegmentMap);
  }

  onChangeTargetSegment($event: any, code: string, index: number) {
    this.targetSegmentMap.set(index, $event);
    this.templateCopyService.changeTargetSegmentMap(this.targetSegmentMap);
  }
}
